export default __webpack_public_path__ + "static/media/weekly-activity-icon.d0bea3a9.png";